import {
  Path,
  FabricImage,
  FabricObject,
  Rect,
  Circle,
  PathProps,
  TOptions,
  RectProps,
  CircleProps,
} from "fabric";

import { addCtrl } from "./addCtrl";

// La roue des formes ! (ordre des changements de formes)
const shapeWheel = ["rect", "rounded", "circle", "heart", "hexagon"] as const;

const HEART_PATH = "M 0 13 Q -1 13 -4 11 C -12 5 -17 -3 -12 -10 C -9 -14 -2 -13 0 -7 C 2 -13 9 -14 12 -10 C 17 -3 11 5 4 11 Q 1 13 0 13 Z"

const HEXAGON_PATH = "M-2 -23.3453C-0.7624 -24.0598 0.7624 -24.0598 2 -23.3453L19.2176 -13.4047C20.4552 -12.6902 21.2176 -11.3697 21.2176 -9.9406V10.4406C21.2176 11.8697 20.4552 13.1902 19.2176 13.9047L2 23.8453C0.7624 24.5598 -0.7624 24.5598 -2 23.8453L-19.2176 13.9047C-20.4552 13.1902 -21.2176 11.8697 -21.2176 10.4406V-9.9406C-21.2176 -11.3697 -20.4552 -12.6902 -19.2176 -13.4047L-2 -23.3453Z"


export const createHeart = (options: Partial<TOptions<PathProps>>) => {
  const minSize = Math.min(options?.height || 40, options?.width || 40) / 2;
  const scaleFactor = minSize / 14; // La hauteur totale du cœur est d'environ 28 unités (de -14 à 14)
  return new Path(HEART_PATH, {
    stroke: "#000000", fill: "", id: "heart",
    originX: "center",
    originY: "center",
    scaleX: scaleFactor, scaleY: scaleFactor,
    ...options
  });
}

export const createImage = async (url: string, options: Partial<TOptions<PathProps>>) => {
  const img = await FabricImage.fromURL(url, { crossOrigin: "anonymous" });
  let scale = 1;
  if (img.width > 300 || img.height > 300) {
    scale = Math.min(300 / img.width, 300 / img.height);
  }
  // pour l'instant en dur, à dynamiser
  img.set({
    scaleX: scale,
    scaleY: scale,
    id: "image",
    layerType: "image",
    ...options,
  });

  addCtrl(img)
  return img
}


export const createRect = (options?: Partial<TOptions<RectProps>>) => {
  return new Rect({ id: "rect", originX: "center", originY: "center", ...options })
}

export const createRoundedRect = (options?: Partial<TOptions<RectProps>>) => {
  const width = options?.width || 40
  const height = options?.width || 40
  const rec = new Rect({ id: "rounded", originX: "center", originY: "center", ry: height * 0.15, rx: width * 0.15, ...options })
  // scaling pour garder les proportions (on change h/w plutot que scale)
  rec.noScaleCache = false;
  rec.on("scaling", (e) => {
    var sX = rec.scaleX
    var sY = rec.scaleY
    rec.width *= sX;
    rec.height *= sY;
    rec.scaleX = 1;
    rec.scaleY = 1;
  })
  return rec
}

export const createCircle = (options?: Partial<TOptions<CircleProps>>) => {
  return new Circle({ id: "circle", originX: "center", originY: "center", ...options })
}

export const createHexagon = (options?: Partial<TOptions<PathProps>>) => {
  return new Path(HEXAGON_PATH, { originX: "center", originY: "center", id: "hexagon", ...options });
}

export const nextShape = (id?: typeof shapeWheel[number]) => {
  if (!id) return "rounded"; // on commence à rounded
  const currentIndex = shapeWheel.indexOf(id);
  const nextIndex = (currentIndex + 1) % shapeWheel.length;
  return shapeWheel[nextIndex];
};

export const switchShape = (obj: FabricObject) => {
  const { fill, stroke, left, top, id, strokeWidth } = obj;
  console.log("before sw", strokeWidth)

  let width = obj.width * obj.scaleX;
  let height = obj.height * obj.scaleY;

  const minSize = Math.min(height, width);

  let radius = obj.radius || minSize / 2;

  if (!width && radius) {
    width = radius * 2;
    height = radius * 2;
  } else {
    radius = minSize / 2
  }
  const shape = nextShape(id)
  const res = createShape(shape, { fill, stroke, left, top, height, width, radius })
  return res
}

export const createShape = (shape: string, { fill, stroke, left, top, height, width, radius }: any) => {
  const strokeWidth = stroke ? 4 : 0
  console.log(strokeWidth)
  switch (shape) {
    case "rect": return createRect({ fill, stroke, left, top, height, width, strokeWidth });
    case "rounded": return createRoundedRect({ fill, stroke, left, top, height, width, strokeWidth });
    case "circle": return createCircle({ radius, fill, stroke, left, top, strokeWidth });
    case "heart": return createHeart({ fill, stroke, left, top, height, width, strokeWidth: strokeWidth / (radius / 14), scaleY: radius / 14, scaleX: radius / 14 });
    case "hexagon": return createHexagon({ fill, stroke, left, top, height, width, strokeWidth: strokeWidth / (radius / 24), scaleY: radius / 24, scaleX: radius / 24 });
  }

}
